import React, { Component } from 'react';
import { Drawer, Col, Row ,Form,Input,Button} from 'antd';
import InfoView from "../InfoView";
import {connect} from "react-redux";
import {handleDrawer,createUserRequest} from "../../appRedux/actions/FZCustomer";

class RequestUserForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      loading:false,
    }
  }
  handleSubmit = e => {
    const {createUserRequest,form}= this.props;
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        createUserRequest(values)
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const {loading}=this.props
    return (
      <div>
        <Drawer
          title="Request New Account"
          width={500}
          placement="right"
          closable={true}
          onClose={()=>{this.props.handleDrawer(false)}}
          visible={this.props.isDrawerVisible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form layout="vertical" style={{marginTop: "10px"}} hideRequiredMark>
            <Row gutter={16}>
              <Col span={20}>

                <Form.Item
                  name="first_name"
                  label="First Name"
                  rules={[{ required: true, message: 'Please enter user name' }]}
                >
                  {getFieldDecorator('first_name', {
                    rules: [{ required: true, message: 'Please input your first name!' }],
                  })(
                       <Input placeholder="Please enter first name" />
                 )}
                </Form.Item>
              </Col>
              <Col span={20}>
                <Form.Item
                  name="last_name"
                  label="Last Name"
                >
                  {getFieldDecorator('last_name', {
                    rules: [{ required: true, message: 'Please input your last name!' }],
                  })(
                    <Input placeholder="Please enter last name" />
                  )}
                </Form.Item>
              </Col>
              <Col span={20}>
                <Form.Item
                  name="email"
                  label="Email"
                >
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: 'Please input your email!' }],
                  })(
                    <Input placeholder="Please enter email" />
                  )}
                </Form.Item>
              </Col>
              <Col span={20}>
                <Form.Item
                  name="password"
                  type="password"
                  label="Password"
                >
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please input your password!' }],
                  })(
                    <Input.Password placeholder="Please enter email" />
                  )}
                </Form.Item>
              </Col>
              <Col span={22}>
                <Form.Item
                  name="phone"
                  label="Phone"
                >
                  {getFieldDecorator('phone', {
                    rules: [{ required: true, message: 'Please input your phone!' }],
                  })(
                    <Input placeholder="Please enter phone" />
                  )}
                </Form.Item>
              </Col>
              <Col span={22}>
                <Form.Item
                  name="website"
                  label="Website"
                >
                  {getFieldDecorator('website', {
                    rules: [{ required: true, message: 'Please input your website!' }],
                  })(
                    <Input placeholder="Please enter website" />
                  )}
                </Form.Item>
              </Col>
                <Col span={22}>
                  <Form.Item
                    name="google_analytics_id"
                    label="Google Analytics ID"
                  >
                    {getFieldDecorator('google_analytics_id', {
                      rules: [{ required: true, message: 'Please input your google analytics!' }],
                    })(
                      <Input placeholder="Please enter google analytics property id" />
                    )}
                  </Form.Item>
                </Col>
                <Col span={22}>
                  <Form.Item
                    name="call_rails_company_id"
                    label="Call Rails Company ID"
                  >
                    {getFieldDecorator('call_rails_company_id', {
                      rules: [{ required: true, message: 'Please input your call rails!' }],
                    })(
                      <Input placeholder="Please enter call rails company id" />
                    )}
                  </Form.Item>
                </Col>
            </Row>
            <div
              style={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
              }}
            >
              <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button onClick={this.handleSubmit} type="primary" loading={loading}>
                Submit
              </Button>
            </div>
          </Form>
        </Drawer>
        <InfoView/>
      </div>
    );
  }
}
const mapStateToProps = ({FZCustomer}) => {
  const {isDrawerVisible,loading} =FZCustomer
  return {isDrawerVisible,loading}
};
const WrappedRequestForm=Form.create()(RequestUserForm);
export default connect(mapStateToProps, {handleDrawer,createUserRequest})(WrappedRequestForm);
